<template>
    <div>
      <video
        autoplay
        ref="video"
        controls
        preload="auto"
        :height="height"
        style="object-fit: fill;width: 100%;"
      ></video>
    </div>
  </template>
  
  <script>
  import Hls from 'hls.js';
  
  export default {
    props: {
      hlsUrl: {
        type: String,
        required: true
      },
      width: {
        type: Number,
        default: 440
      },
      height: {
        type: Number,
        default: 214
      }
    },
    mounted() {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(this.hlsUrl);
        hls.attachMedia(this.$refs.video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          this.$refs.video.play();
        });
      } else if (this.$refs.video.canPlayType('application/vnd.apple.mpegurl')) {
        this.$refs.video.src = this.hlsUrl;
        this.$refs.video.addEventListener('loadedmetadata', function () {
          this.$refs.video.play();
        });
      }
    }
  }
  </script>
  